import React from 'react';
import {Box, Grid, Typography} from '@mui/material';
import {images} from '../../constants/image';
import colors from '../../theme/colors';

function AccessRightsNoPermissionView() {
  return (
    <Grid justifyContent="space-between" container spacing={2} columns={16}>
      <Grid item xs={16}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            padding: 6,
            height: '70vh',
            minHeight: '20rem',
            gap: 5,
            backgroundColor: colors.white,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img src={images.icon_cicle_warning} width={150} height={150} />
          </Box>
          <Typography variant="h3" fontSize={20} fontWeight="bolder">
            You do not have permission to access this page
          </Typography>
          <Typography
            fontSize={13}
            fontWeight={400}
            lineHeight={1.5}
            letterSpacing="-0.143px"
          >
            Contact a super administrator for permission or to report an error.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

export default AccessRightsNoPermissionView;
